import { useMemo } from "react";
import { BudgetStatusEnum } from "../../../../enums/budgetStatus";
import { BudgetRecipientEnum } from "../types";
import { useConsultantJourney } from "./useConsultantJourney";
import { useFactoryJourney } from "./useFactoryJourney";
import { useManagerJourney } from "./useManagerJourney";

interface IUseJourneySelectorParams {
  isEditMode: boolean;
  profile?: BudgetRecipientEnum;
  recipient?: string;
  status?: BudgetStatusEnum;
  orcamentoStatus?: BudgetStatusEnum;
}

export const useJourneySelector = (params: IUseJourneySelectorParams) => {
  const { isEditMode, profile, recipient, status, orcamentoStatus } = params;

  const consultantJourney = useConsultantJourney({
    isEditMode,
    profile,
    recipient,
    status,
    orcamentoStatus,
  });

  const factoryJourney = useFactoryJourney({
    isEditMode,
    profile,
    recipient,
    status,
    orcamentoStatus,
  });

  const managerJourney = useManagerJourney({
    isEditMode,
    profile,
    recipient,
    status,
    orcamentoStatus,
  });

  const activeJourney = useMemo(() => {
    switch (profile) {
      case BudgetRecipientEnum.CONSULTANT:
        return consultantJourney;
      case BudgetRecipientEnum.TOWER:
        return factoryJourney;
      case BudgetRecipientEnum.MANAGER:
        return managerJourney;
      default:
        return consultantJourney;
    }
  }, [profile, consultantJourney, factoryJourney, managerJourney]);

  const allOptions = useMemo(
    () => [
      {
        id: BudgetRecipientEnum.CONSULTANT,
        label: "Consultor da Concessionária",
      },
      { id: BudgetRecipientEnum.TOWER, label: "Volks|total" },
      { id: BudgetRecipientEnum.MANAGER, label: "Gestor de Frotas" },
    ],
    []
  );

  const recipientOptions = useMemo(() => {
    return activeJourney.getRecipientOptions(allOptions);
  }, [activeJourney, allOptions]);

  return {
    activeJourney,
    recipientOptions,
    isConsultant: consultantJourney.isConsultant,
    isFactory: factoryJourney.isFactory,
    isManager: managerJourney.isManager,
  };
};
